module.exports = __webpack_public_path__ + "static/img/annie-gray-WEWTGkPUVT0-unsplash_thumb.2608938.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/annie-gray-WEWTGkPUVT0-unsplash_thumb.png
// module id = B9gP
// module chunks = 4